import axios from "axios";


const API_URL= process.env.VUE_APP_API;


export const axiosApp = axios.create({
    baseURL: API_URL,
    headers: {
      "Content-type":'application/json;',
      "token": localStorage.getItem("token"),
      "site":localStorage.getItem("site")
    },
  });

  axiosApp.interceptors.request.use( 
    function (config) {   
      config.headers.token = localStorage.getItem("token");   
      config.headers.site = localStorage.getItem("site");   
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  axiosApp.interceptors.response.use(
    (response) => {
      if (!response.data.status) {    
        // if (response.data.message.indexOf("token bilgisi geçersiz") >= 0) {
        //       localStorage.clear();
        //       router.push("/login");          
        // }
      }
      return response;
      
    },
    (error) => {
        console.log(error);
      throw error;
    }
  );

//***sitesi genel gidenler için yapıldı ilerde kaldırılabilir !!! */
  export const axiosPublicApp = axios.create({
    baseURL: API_URL,
    headers: {
      "Content-type":'application/json;',
      "token": localStorage.getItem("token"),
      "site":'genel'
    },
  });

  axiosPublicApp.interceptors.request.use( 
    function (config) {   
      config.headers.token = localStorage.getItem("token");   
      config.headers.site = 'genel';   
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  axiosPublicApp.interceptors.response.use(
    (response) => {
      if (!response.data.status) {    
        // if (response.data.message.indexOf("token bilgisi geçersiz") >= 0) {
        //       localStorage.clear();
        //       router.push("/login");          
        // }
      }
      return response;
      
    },
    (error) => {
        console.log(error);
      throw error;
    }
  );



// WEBPACK FOOTER //
// ./src/utils/appAxios.js